import "./loader.scss";

const LoadingSpinner = () => {
  return (
    <div className="spinner-overlay">
      <div className="spinner" />
      <p>Loading please wait...</p>
    </div>
  );
};

export default LoadingSpinner;
